import type {Middleware} from '@linx-security/api-specs';
import type {Logger} from 'pino';

import {HTTPStatus} from '../types';

import {baseLogger} from './log-middleware';

export const getSessionMiddleware = (base: Logger = baseLogger, onSessionRevoke: (args: Response) => Promise<void>) => {
  const logger = base.child({scope: `session-middleware`}, {});

  return {
    post: async context => {
      if (!context.response) return context.response;

      const {status, statusText, url} = context.response;
      if (HTTPStatus.UNAUTHORIZED !== status) return context.response;

      logger.info({status, statusText, url}, `Unauthorized API response, revoking session`);
      await onSessionRevoke(context.response);

      return context.response;
    },
  } satisfies Middleware;
};
